import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { iconPosition } from './icons';
import defaultIconSprite from '../../assets/sprites/icons/icons-sprite.svg';

import './Icons.scss';

const Icons = ({ id, type, onClick, small, iconSprite }) => {
  const position = iconPosition(type);
  const [sprite, setSprite] = useState(iconSprite);
  useEffect(() => {
    let newSprite = new Image();
    newSprite.src = iconSprite;
    setSprite(newSprite.src);
  }, [iconSprite]);
  return (
    <span
      id={id}
      className={`icons ${small && 'small'}`}
      style={{ backgroundImage: `url(${sprite})`, backgroundPosition: position }}
      onClick={onClick}
    />
  );
};

const mapStateToProps = (state) => ({
  iconSprite: get(state, 'common.resources.brandSprite', defaultIconSprite),
});

export default connect(mapStateToProps, null)(Icons);
